import styled from 'styled-components'
import { Button } from 'antd'

export const Wrapper = styled.div`
  padding: 24px;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const StyledButton = styled(Button)`
  &:not(:first-child) {
    margin-top: 10px;
  }
`

export const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PreviewHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const PreviewBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PreviewFooter = styled.div`
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  text-align: center;
`

export const CtaButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
`

export const CtaButton = styled(Button)`
  border-radius: 6px;
  font-weight: 500;
`